// import axios from 'axios';
// import store from '../store';

// el -- loops element (bus) // val -- respective filters
import moment from "moment";

export function timeFilter(el, val) {

  if (val.length > 0) {

    const temp = new Date(el.DepartureTime);
    const t = temp.getHours() < 10 ? `0${temp.getHours()}` : temp.getHours() + ":" + temp.getMinutes();

    if (val.includes("Before-10AM") && t >= '00:00' && t <= '10:00') {
      return true;
    }

    if (val.includes("10AM - 5PM") && t >= '10:00' && t <= '17:00') {
      return true;
    }

    if (val.includes("5PM-11PM") && t >= '17:01' && t <= '23:00') {
      return true;
    }

    if (val.includes("After-11PM") && t >= '23:01' && t <= '24:00') {
      return true;
    }

    // if (val.length > 0) {

    //   const temp = new Date(el.DepartureTime);
    //   const t = temp.getHours()+":"+temp.getMinutes();

    //   if(val.indexOf("Early Morning (Before 10:0 Hrs.)") >=0 && t >= '00:00' && t <= '10:00'){
    //       return true;
    //   }

    //   if(val.indexOf("Day (10:00 - 17:00 Hrs.)") >=0 && t >= '10:00' && t <= '17:00'){
    //       return true;
    //   }

    //   if(val.indexOf("Evening (17:01 - 23:00 Hrs.)") >=0 && t >= '17:01' && t <= '23:00'){
    //       return true;
    //   }

    //   if(val.indexOf("Late Night (After 23:01 Hrs.)") >=0 && t >= '23:01' && t <= '24:00' ){
    //     return true;
    //   }

    /* if (val.indexOf(0) >= 0 && temp.getHours() >= 0 && temp.getHours() < 6) {
      return true;
    }

    if (val.indexOf(1) >= 0 && temp.getHours() >= 6 && temp.getHours() < 12) {
      return true;
    }

    if (val.indexOf(2) >= 0 && temp.getHours() >= 12 && temp.getHours() < 18) {
      return true;
    }

    if (val.indexOf(3) >= 0 && temp.getHours() >= 18 && temp.getHours() < 24) {
      return true;
    } */

    return false;

  }

  return true;
}

export function coachType(el, val, loop) {
  if (val.length > 0) {

    const chkSeater = (val.indexOf(loop[2]) >= 0) ? checkSeater(el, val, loop) : true;
    const chkSleeper = (val.indexOf(loop[3]) >= 0) ? checkSleeper(el, val, loop) : true;
    const chkAC = ((val.indexOf(loop[0]) >= 0 && val.indexOf(loop[1]) >= 0) || (val.indexOf(loop[0]) === -1 && val.indexOf(loop[1]) === -1)) ? true : checkAC(el, val, loop);
    const chkVolvo = ((val.indexOf(loop[4]) >= 0 && val.indexOf(loop[5]) >= 0) || (val.indexOf(loop[4]) === -1 && val.indexOf(loop[5]) === -1)) ? true : checkPremium(el, val, loop);
    //const chkMercedes = checkMercedes(el, val, loop);

    if (chkSeater && chkSleeper && chkAC && chkVolvo) {
      return true;
    } else {
      return false;
    }
  }
  return true;
}

function checkSeater(el, val, loop) {
  const seater = el.HasSeater;
  // const sleeper = el.HasSeater;
  if (val.indexOf(loop[2]) >= 0) {
    return seater;
  } else {
    return !seater;
  }
}

function checkSleeper(el, val, loop) {
  const sleeper = el.HasSleeper;
  if (val.indexOf(loop[3]) >= 0) {
    return sleeper;
  } else {
    return !sleeper;
  }
}

function checkAC(el, val, loop) {
  const ac = el.HasAC;
  if (val.indexOf(loop[0]) >= 0) {
    return ac;
  } else {
    return !ac;
  }
}

function checkPremium(el, val, loop) {
  const volvo = el.BusType.toLowerCase().indexOf('premium') >= 0 || el.BusType.toLowerCase().indexOf('mercedes benz') >= 0 || el.BusType.toLowerCase().indexOf('volvo') >= 0;
  if (val.indexOf(loop[4]) >= 0) {
    return volvo;
  } else {
    return !volvo;
  }
}

/* function checkMercedes(el, val, loop) {
  const mercedes = el.BusType.toLowerCase().indexOf('mercedes benz') >= 0;
  if (val.indexOf(loop[6]) >= 0) {
    return mercedes;
  } else {
    return !mercedes;
  }
} */

export function amenFilter(el, val, amenArr) {
  if (val.length > 0) {
    let isAmen = false;
    if (el.AmenitiesType.length > 0) {
      val.forEach((value, index) => {
        isAmen = el.AmenitiesType.indexOf(value) >= 0 ? (index === 0 ? true : isAmen && true) : false;
      })
    }
    if (isAmen) {
      return true;
    } else {
      return false;
    }
  }
  return true;
}

export function busServiceType(el, val, loop) {

  if (val.length > 0 && loop != undefined && loop.length > 0) {
    // console.log("el", el);
    // console.log("val", val);
    // console.log("loop", loop);
    // const chkSwiftDeluxe = (val.indexOf(loop[0]) >= 0) ? checkSwiftDeluxe(el, val, loop) : false;
    // const chkSuperDeluxe = (val.indexOf(loop[1]) >= 0) ? checkSuperDeluxe(el, val, loop) : false;
    // const chkSwiftACGaruda = (val.indexOf(loop[2]) >= 0) ? checkSwiftACGaruda(el, val, loop) : false;
    // const chkSwiftGajrajACSleerper = (val.indexOf(loop[3]) >= 0) ? checkSwiftGajrajACSleerper(el, val, loop) : false;

    // if (chkSwiftDeluxe || chkSuperDeluxe || chkSwiftACGaruda || chkSwiftGajrajACSleerper) {
    //   return true;
    // } else {
    //   return false;
    // }
    // console.log("loop", loop);
    // console.log("el", el);
    // console.log("val", val);
    if (loop.indexOf(val[0]) >= 0 && el.ServiceType === val[0] ||
      loop.indexOf(val[1]) >= 0 && el.ServiceType === val[1] ||
      loop.indexOf(val[2]) >= 0 && el.ServiceType === val[2] ||
      loop.indexOf(val[3]) >= 0 && el.ServiceType === val[3] ||
      loop.indexOf(val[4]) >= 0 && el.ServiceType === val[4] ||
      loop.indexOf(val[5]) >= 0 && el.ServiceType === val[5] ||
      loop.indexOf(val[6]) >= 0 && el.ServiceType === val[6] ||
      loop.indexOf(val[7]) >= 0 && el.ServiceType === val[7] ||
      loop.indexOf(val[8]) >= 0 && el.ServiceType === val[8] ||
      loop.indexOf(val[9]) >= 0 && el.ServiceType === val[9]
    ) {
      return true;
    } else {
      return false;
    }
  }
  return true;
}

export function pickupsFilter(el, val, loop) {
  if (val.length > 0 && loop != undefined && Object.keys(loop).length > 0) {
    var routeCodes = [];
    if (val.length > 0) {
      val.forEach(pkp => {
        if (loop[pkp].length > 0) {
          loop[pkp].forEach(rc => {
            routeCodes.push(rc);
          });
        }
      });
    }
    if (routeCodes.length > 0) {
      return routeCodes.includes(el.RouteScheduleId);
    }
  }
  return true;
}

export function dropoffFilter(el, val, loop) {
  if (val.length > 0 && loop != undefined && Object.keys(loop).length > 0) {
    var routeCodes = [];
    if (val.length > 0) {
      val.forEach(drp => {
        if (loop[drp].length > 0) {
          loop[drp].forEach(rc => {
            routeCodes.push(rc);
          });
        }
      });
    }
    if (routeCodes.length > 0) {
      return routeCodes.includes(el.RouteScheduleId);
    }
  }
  return true;
}

export function busFareFilter(el, val) {
  if (val.length > 0) {
    if (el.DiscFare >= val[0] && el.DiscFare <= val[1]) {
      return true;
    } else {
      return false;
    }
  }
  return true;
}

export function busLayoverFilter(el, val) {

  const urlParams = new URLSearchParams(window.location.search);
  const linkfromstoptocity = urlParams.get("linkfromstoptocity");
  const token = urlParams.get("token");
  const mode = urlParams.get("mode");

  if(mode == 'roundtrip' && linkfromstoptocity && token && val.length > 0) {

    const startTripArrivalTime = JSON.parse(sessionStorage.getItem("startTripArrivalTime"));
    const deptStartFrom = moment(startTripArrivalTime).add(parseInt(val[0]), "hours").format("YYYY-MM-DDTHH:mm:ss");
    const deptEndTo = moment(startTripArrivalTime).add(parseInt(val[1]), "hours").format("YYYY-MM-DDTHH:mm:ss");

    // console.log("----------startTripArrivalTime---------- ",startTripArrivalTime);
    // console.log("deptStartFrom ",deptStartFrom);
    // console.log("DepartureTime ",el.DepartureTime);
    // console.log("deptEndTo ",deptEndTo);

    if((new Date(el.DepartureTime).getTime() >= new Date(deptStartFrom).getTime()) && (new Date(el.DepartureTime).getTime() <= new Date(deptEndTo).getTime())){
        // console.log("Found for -> ",el.TripCode);
        return true;
    }else{
        return false;
    }

  }
  
  return true;
}

function checkSwiftDeluxe(el, val, loop) {
  const swiftDeluxe = el.ServiceType.toLowerCase().includes("swift deluxe");
  if (val.indexOf(loop[0]) >= 0) {
    return swiftDeluxe
  } else {
    // return !swiftDeluxe;
    return false;
  }
}

function checkSuperDeluxe(el, val, loop) {
  const superDeluxe = el.ServiceType.toLowerCase().includes("super deluxe");
  if (val.indexOf(loop[1]) >= 0) {
    return superDeluxe
  } else {
    // return !superDeluxe;
    return false;
  }
}

function checkSwiftACGaruda(el, val, loop) {
  const swiftacGaruda = el.ServiceType.toLowerCase().includes("swift ac garuda");
  if (val.indexOf(loop[2]) >= 0) {
    return swiftacGaruda
  } else {
    // return !swiftacGaruda;
    return false;
  }
}

function checkSwiftGajrajACSleerper(el, val, loop) {
  const swiftgajrajACSleeper = el.ServiceType.toLowerCase().includes("swift ac gajraj sleeper");
  if (val.indexOf(loop[3]) >= 0) {
    return swiftgajrajACSleeper
  } else {
    // return !swiftgajrajACSleeper;
    return false;
  }
}



